import { __require as t } from "./Response.mjs";
var e, s;
function r() {
  if (s) return e;
  s = 1;
  const r = t();
  return e = class {
    constructor(t, e, s = "") {
      this.latitude = t.toFixed(8), this.longitude = e.toFixed(8), this.source = s, this.response = new r(), this.customParameters = {};
    }
    addCustomParameter(t, e) {
      this.customParameters[t] = e;
    }
  };
}
export { r as __require };